<template>
  <div v-if="advice" class="global-booking-alert">
    <div class="trip-alert" :class="alertClass">
      <span class="dot"></span>
      <span class="text">
        {{ alertText }}
        <template v-if="advice === 'prevent'">
          — Call to book at {{ supportNumber }}
        </template>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "TripAlertBanner",
  props: {
    advice: {
      type: String,
      default: null,
      validator: (value) => [null, "warn", "prevent"].includes(value),
    },
    supportNumber: {
      type: String,
      default: "877-924-0303",
    },
  },
  computed: {
    alertClass() {
      return this.advice === "prevent" ? "is-danger" : "is-warning";
    },
    alertText() {
      return this.advice === "prevent"
        ? "Starts in next 4 hours"
        : "Starts in next 24 hours";
    },
  },
};
</script>

<style scoped>
.global-booking-alert {
  display: block;
  margin-bottom: 12px;
}

.trip-alert {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.5;
}

.trip-alert.is-warning {
  background-color: #fff3cd;
  color: #856404;
}

.trip-alert.is-danger {
  background-color: #f8d7da;
  color: #721c24;
}

.trip-alert .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.trip-alert.is-warning .dot {
  background-color: #856404;
}

.trip-alert.is-danger .dot {
  background-color: #721c24;
}

.trip-alert .text {
  font-size: 16px;
}

/* Mobile */
@media screen and (max-width: 768px) {
  .trip-alert {
    font-size: 12px;
    padding: 5px 10px;
  }

  .trip-alert .text {
    font-size: 12px;
  }

  .trip-alert .dot {
    width: 6px;
    height: 6px;
  }
}
</style>

